import React from "react";
import styled from "styled-components";

export default styled.img`
    width: 40px;
    height: 40px;
    left: 50%;
    top: 50%;
    position: absolute;
    transform: translate(-50%, -50%);
`;